import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import Bubbles from '../game/Bubbles';
import Spelly from '../game/Spelly';
import Tentacle from '../game/Tentacle';
import gameData from '../gameData';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';
import LocalizationUIAssets from '../Localization-UIAssets';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import ABCyaLib from '@abcya/abcya_lib';

export default class Title extends Phaser.Scene {
  static get KEY() { return 'Title'; }

  constructor() {
    super({ key: Title.KEY });
  }

  init() {
    this.bg = null;

    this.nextLvlCont = null;

    this.wavesB = null;
    this.wavesF = null;

    this.subCont = null;
    this.sub = null;
    this.hatch = null;
    this.periscope = null;
    this.cockpitMask = null;

    this.title1 = null;
    this.title2 = null;
    this.title3 = null;
    this.go = null;
    this.tentacle = null;

    this.octoWave = null;
    this.randWave1Wave = null;
    this.randWave2Wave = null;
    this.randWave3Wave = null;

    this.subTween = null;
    this.subWaveTween = null;
    this.randWave1Tween = null;
    this.randWave2Tween = null;
    this.randWave3Tween = null;

    this.bubble = null;
    this.bubbleText = null;
    this.bubbleCont = null;

    this.clouds = [];

    /** @type {Phaser.GameObjects.Image[]} */
    this.levels = [];

    this.spelly = null;
  }

  create() {
    console.log('TITLE SCEEN');
    gameData.config.gameOver = false;
    gameData.config.gamePaused = false;
    gameData.config.level = 1;
    gameData.config.levelWordBank = [];

    this._jingleAudio = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._submarine_spelling_practice_jingle,this._jingleAudio, 1, true, .2);

    this.createNextScene();

    this.bg = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._1_Welcome_and_Level_Screen_Bkgd_1,this).setOrigin(0);
    this.wavesB = ABCyaPhaser.Images.addImage(0,this.scale.height, UIAssetKeys._1_Welcome_and_Level_Screen_Wave_Bkgd, this).setOrigin(0, 1);

    this.createClouds();
    this.createSub();
    this.createSpelly(true);
    this.createWaves();
    this.createTitle();
    this.createTentacle();
  }

  createNextScene () {
    this.nextLvlCont = this.add.container();
    const bg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._4_Level_1_Lvl1_Bkgd , this.nextLvlCont).setOrigin(0);

    const coral1 = ABCyaPhaser.Images.addImage(-10, this.scale.height + 20, UIAssetKeys._4_Level_1_Lvl1_CoralLeft, this.nextLvlCont).setOrigin(0, 1);
    const coral2 = ABCyaPhaser.Images.addImage(this.scale.width + 10, this.scale.height + 20, UIAssetKeys._4_Level_1_Lvl1_CoralRightBkgd, this.nextLvlCont).setOrigin(1);
    const seaweed1 = ABCyaPhaser.Images.addImage(-10, this.scale.height / 2 - 80, UIAssetKeys._4_Level_1_Lvl1_Seaweed1, this.nextLvlCont).setOrigin(0.5);
    const seaweed2 = ABCyaPhaser.Images.addImage(-10, this.scale.height / 2 + 80, UIAssetKeys._4_Level_1_Lvl1_Seaweed2, this.nextLvlCont).setOrigin(0.1, 0.5);
    const seaweed3 = ABCyaPhaser.Images.addImage(this.scale.width - 170, this.scale.height + 10, UIAssetKeys._4_Level_1_Lvl1_Seaweed3, this.nextLvlCont).setOrigin(0.5, 1);
    const seaweed4 = ABCyaPhaser.Images.addImage(this.scale.width, this.scale.height / 2 + 175, UIAssetKeys._4_Level_1_Lvl1_Seaweed4, this.nextLvlCont).setOrigin(0.7, 1);
    const anenomes = ABCyaPhaser.Images.addImage(this.scale.width, this.scale.height, UIAssetKeys._4_Level_1_Lvl1_Anenomes, this.nextLvlCont).setOrigin(0.9);
  }

  createClouds () {
    for (let i = 0; i < 2; i++) {
      const rndCloud = Phaser.Math.Between(1, 2);

      const cloud = ABCyaPhaser.Images.addImage(0, 0,rndCloud === 1 ? UIAssetKeys._1_Welcome_and_Level_Screen_Cloud1 : UIAssetKeys._1_Welcome_and_Level_Screen_Cloud2, this).setOrigin(0.5);
      this.clouds.push(cloud);

      if (i === 0) {
        cloud.setPosition(-cloud.width / 2 - 70, 0);
        this.moveClouds(cloud, 'right');
      }
      else {
        cloud.setPosition(this.scale.width + cloud.width / 2 + 70, 0);
        this.moveClouds(cloud, 'left');
      }
    }
  }

  /**
   * 
   * @param {Phaser.GameObjects.Image} obj 
   * @param {string} dir 
   */
  moveClouds (obj, dir) {
    const rndDel = Phaser.Math.Between(0, 5000);
    const rndLen = Phaser.Math.Between(30000, 50000);
    const randScale = Phaser.Math.FloatBetween(.75, 1.5);
    const randY = Phaser.Math.Between(-50, 150);

    obj.setScale(randScale);
    obj.setPosition(obj.x, randY);

    if (dir === 'right') {
      ABCyaPhaser.Tweens.addTween(obj, rndLen, { x: this.scale.width + obj.width, delay: rndDel }, Phaser.Math.Easing.Linear, () => {
        this.moveClouds(obj, 'left');
      });
    }
    else {
      ABCyaPhaser.Tweens.addTween(obj, rndLen, { x: -obj.width, delay: rndDel }, Phaser.Math.Easing.Linear, () => {
        this.moveClouds(obj, 'right');
      });
    }
  }

  createSub () {
    this.subCont = this.add.container();

    this.periscope = ABCyaPhaser.Images.addImage(140, -260, UIAssetKeys._1_Welcome_and_Level_Screen_periscope, this.subCont).setOrigin(0);

    this.sub = ABCyaPhaser.Images.addImage(0, 55, UIAssetKeys._1_Welcome_and_Level_Screen_Sub_BodyBkgd, this.subCont).setOrigin(0.5);

    this.hatch = ABCyaPhaser.Images.addImage(-29, -128, UIAssetKeys._1_Welcome_and_Level_Screen_Sub_Hatch, this.subCont).setOrigin(0.05, 0.95);

    this.subCont.setPosition(175, this.scale.height + 100);

    ABCyaPhaser.Tweens.addTween(this.subCont, 3000, { y: 440 }, Phaser.Math.Easing.Back.Out, () => {
      this.idleSub();
    });
  }

  idleSub () {
    this.spelly.exitCockpit();

    this.subTween = ABCyaPhaser.Tweens.addTween(this.subCont, 4000, { y: 460, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
  }

  /**
   * 
   * @param {boolean} cockpit 
   */
  createSpelly (cockpit) {
    if (cockpit) {
      this.spelly = new Spelly(this, 'cockpit');
      this.subCont.add(this.spelly);
      this.spelly.setPosition(350, 185);

      this.cockpitMask = this.add.graphics({ fillStyle: { alpha: 0 } });
      this.cockpitMask.fillRect(255,-50,220, 185);

      this.spelly.mask = this.cockpitMask.createGeometryMask();
    }
    else {
      if (this.spelly) this.spelly.destroy();

      this.spelly = new Spelly(this, 'hatch');
      this.subCont.addAt(this.spelly, 1);
      this.spelly.setPosition(50, 40);

      this.time.delayedCall(500, this.openHatch, null, this);
    }
  }

  openHatch () {
    this.spelly.openHatch();

    ABCyaPhaser.Tweens.addTween(this.spelly, 1000, { y: -70 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.hatch, 1000, { angle: -85, y: -132 }, Phaser.Math.Easing.Quadratic.Out);
  }

  createWaves () {
    this.wavesF = ABCyaPhaser.Images.addImage(0, this.scale.height,UIAssetKeys._1_Welcome_and_Level_Screen_Wave_Midgd, this).setOrigin(0, 1);

    this.randWave1Wave = ABCyaPhaser.Images.addImage(150, 625, UIAssetKeys._1_Welcome_and_Level_Screen_Wave_Frgd1, this).setOrigin(0.5);

    this.randWave2Wave = ABCyaPhaser.Images.addImage(600, 650, UIAssetKeys._1_Welcome_and_Level_Screen_Wave_Frgd1, this).setOrigin(0.5);

    this.randWave3Wave = ABCyaPhaser.Images.addImage(920, 725, UIAssetKeys._1_Welcome_and_Level_Screen_Wave_Frgd2, this).setOrigin(0.5);

    this.subWaveTween = ABCyaPhaser.Tweens.addTween(this.wavesF, 3500, { x: -30, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
    this.randWave1Tween = ABCyaPhaser.Tweens.addTween(this.randWave1Wave, 2000, { x: 130, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
    this.randWave2Tween = ABCyaPhaser.Tweens.addTween(this.randWave2Wave, 3000, { x: 620, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
    this.randWave3Tween = ABCyaPhaser.Tweens.addTween(this.randWave3Wave, 2000, { x: 900, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
  }

  createTitle () {
    this.title1 = ABCyaPhaser.Images.addImage(725, 65, UIAssetKeys._1_Welcome_and_Level_Screen_Title_Submarine, this).setOrigin(0.5)
      .setScale(0);

    this.title2 = ABCyaPhaser.Images.addImage(725, 208, UIAssetKeys._1_Welcome_and_Level_Screen_Title_SpellingPractice, this).setOrigin(0.5)
      .setScale(0);

    this.title3 = ABCyaPhaser.Images.addImage(
      725,
      340,
      ABCyaLib.Environment.instance.gameConfig.subtitle === null ? UIAssetKeys._1_Welcome_and_Level_Screen_Title_WithSpelly : ABCyaLib.Environment.instance.gameConfig.subtitle,
      this
    ).setOrigin(0.5)
      .setScale(0);

    this.go = ABCyaPhaser.Images.addImage(850, 590, UIAssetKeys._1_Welcome_and_Level_Screen_GoBtn, this).setOrigin(0.5)
      .setScale(0);

    ABCyaPhaser.Tweens.addTween(this.title1, 1000, { scale: 1, delay: 3000 }, Phaser.Math.Easing.Back.Out, () => ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._Intro_Favorite, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE));
    ABCyaPhaser.Tweens.addTween(this.title2, 1000, { scale: 1, delay: 3250 },Phaser.Math.Easing.Back.Out);
    ABCyaPhaser.Tweens.addTween(this.title3, 1000, { scale: 1, delay: 3500 },Phaser.Math.Easing.Back.Out);
    ABCyaPhaser.Tweens.addTween(this.go, 1000, { scale: 1, delay: 6000 },Phaser.Math.Easing.Back.Out, () => {
      this.go.setInteractive({ useHandCursor: true }).once(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.goToSelect, this);
    });
  }

  goToSelect () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

    this.go.disableInteractive();
    this.closeHatch();

    if (ABCyaLib.Environment.instance.gameConfig.gameMode !== null) {
      gameData.config.gameMode = ABCyaLib.Environment.instance.gameConfig.gameMode;
      ABCyaPhaser.Tweens.addTween(this.go, 500, { scale: 0 }, Phaser.Math.Easing.Back.In);
      this.tentacle.tweenOut();
      this.time.delayedCall(1500, this.createTransition, null, this);
      return;
    }

    ABCyaPhaser.Tweens.addTween(this.go, 500, { scale: 0 }, Phaser.Math.Easing.Back.In, () => this.createSelect());

    ABCyaPhaser.Tweens.addTween(this.title1, 500, { scale: 0.6, x: this.scale.width / 2, y: 35 }, Phaser.Math.Easing.Back.In);
    ABCyaPhaser.Tweens.addTween(this.title2, 500, { scale: 0.6, x: this.scale.width / 2, y: 120 }, Phaser.Math.Easing.Back.In);
    ABCyaPhaser.Tweens.addTween(this.title3, 500, { scale: 0 }, Phaser.Math.Easing.Back.In);
  }

  closeHatch () {
    this.spelly.closeHatch();

    ABCyaPhaser.Tweens.addTween(this.spelly, 1000, { y: 80 }, Phaser.Math.Easing.Back.In);
    ABCyaPhaser.Tweens.addTween(this.hatch, 1000, { angle: 0, y: -128 }, Phaser.Math.Easing.Back.In, () => this.goToCockpit());
  }

  goToCockpit () {
    if (this.spelly) this.spelly.destroy();

    this.createSpelly(true);
    this.spelly.setPosition(130, 185);
    this.spelly.lArm.angle = 60;
    this.spelly.rArm.angle = 60;

    ABCyaPhaser.Tweens.addTween(this.spelly, 1000, { x: 350 }, Phaser.Math.Easing.Quadratic.Out, () => this.spelly.enterCockpit());
  }

  createSelect () {
    this.go.destroy();

    this.time.delayedCall(1000, this.createBubble, null, this);

    for (let i = 1; i <= 6; i++) {
      const frame = i < 6 ? `LvlBtn${i}` : UIAssetKeys._1_Welcome_and_Level_Screen_LvlBtn6;
      const atlas = i < 6 ? ABCyaPhaser.Images.LOCALIZATION_ATLAS : ABCyaPhaser.Images.DEFAULT_ATLAS;
      const level = ABCyaPhaser.Images.addImage(710, -100, frame, this, atlas).setOrigin(0);
      this.levels.push(level);

      ABCyaPhaser.Tweens.addTween(level, 1000, { y: 40 + (115 * (i - 1)), delay: 100 * (7 - i - 1) },Phaser.Math.Easing.Back.Out, () => {
        level.setInteractive({ useHandCursor: true }).once(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, () => this.tweenOutTitle(level));
      });
    }
  }

  createBubble () {
    this.bubbleCont = this.add.container();
    this.subCont.add(this.bubbleCont);

    this.bubble = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._1_Welcome_and_Level_Screen_WordBbl_LvlScrn,this.bubbleCont).setOrigin(0.6, 1);

    const txt = 'Select a\n' +
			'level to\n' +
			'explore!';
    this.bubbleText = ABCyaPhaser.Text.addText(-25, -130, 30, 0x21409a, FontKeys._rolling_no_oneregular, txt, this.bubbleCont,true).setOrigin(0.5);
    this.bubbleText.setLineSpacing(5);
    this.bubbleCont.setScale(0, 0);
    this.bubbleCont.setPosition(400, -25);

    ABCyaPhaser.Tweens.addTween(this.bubbleCont, 500, { scale: 1 }, Phaser.Math.Easing.Back.Out, () => this.spelly.speak('select'));
  }

  /**
   * 
   * @param {Phaser.GameObjects.Image} button 
   */
  tweenOutTitle (button) {
    for (let i = 0; i < this.levels.length; i++) {
      this.levels[i].disableInteractive();
    }

    const atlas = ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE;

    if (button.frame.name === LocalizationUIAssets._LvlBtn1) {
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._pre_primer, this, 1, false, 0, atlas);
      gameData.config.gameMode = 1;
    }
    else if (button.frame.name === LocalizationUIAssets._LvlBtn2) {
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._primer, this, 1, false, 0, atlas);
      gameData.config.gameMode = 2;
    }
    else if (button.frame.name === LocalizationUIAssets._LvlBtn3) {
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._first_grade, this, 1, false, 0, atlas);
      gameData.config.gameMode = 3;
    }
    else if (button.frame.name === LocalizationUIAssets._LvlBtn4) {
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._second_grade, this, 1, false, 0, atlas);
      gameData.config.gameMode = 4;
    }
    else if (button.frame.name === LocalizationUIAssets._LvlBtn5) {
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._third_grade, this, 1, false, 0, atlas);
      gameData.config.gameMode = 5;
    }
    else if (button.frame.name === UIAssetKeys._1_Welcome_and_Level_Screen_LvlBtn6) {
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._all_words, this, 1, false, 0, atlas);
      gameData.config.gameMode = 6;
    }

    this.time.delayedCall(1000, this.createTransition, null, this);

    this.tentacle.tweenOut();

    this.tweens.killTweensOf(this.subCont);
    this.subTween.stop();

    ABCyaPhaser.Tweens.addTween(this.bubbleCont, 500, { scale: 0 }, Phaser.Math.Easing.Back.Out);
    ABCyaPhaser.Tweens.addTween(this.subCont, 1500, { y: this.scale.height + 100 }, Phaser.Math.Easing.Back.In);
  }

  createTransition () {
    new Bubbles(this);
  }

  createTentacle () {
    this.tentacle = new Tentacle(this);
    this.add.existing(this.tentacle);
  }

  cleanUp () {
    this.bg.destroy();

    if (this.bubbleCont) this.bubbleCont.destroy();

    if (this.levels.length > 0) {
      for (let i = 0; i < this.levels.length; i++) {
        this.levels[i].destroy();
      }
    }

    if (this.clouds.length > 0) {
      for (let c = 0; c < this.clouds.length; c++) {
        this.clouds[c].destroy();
      }
    }

    this.spelly.cleanUp();
    this.spelly.destroy();

    this.tentacle.cleanUp();
    this.tentacle.destroy();

    this.title1.destroy();
    this.title2.destroy();
    if (this.title3) this.title3.destroy();

    this.tweens.killTweensOf(this.subCont);
    this.tweens.killTweensOf(this.wavesF);
    this.tweens.killTweensOf(this.randWave1Wave);
    this.tweens.killTweensOf(this.randWave2Wave);
    this.tweens.killTweensOf(this.randWave3Wave);

    this.subTween.stop();
    this.subWaveTween.stop();
    this.randWave1Tween.stop();
    this.randWave2Tween.stop();
    this.randWave3Tween.stop();

    this.subCont.destroy();

    this.wavesB.destroy();
    this.wavesF.destroy();
    this.randWave1Wave.destroy();
    this.randWave2Wave.destroy();
    this.randWave3Wave.destroy();

    this._jingleAudio.destroy();
  }

  update(time, delta) {
    if (this.cockpitMask) {
      this.cockpitMask.setPosition(this.subCont.x, this.subCont.y);
    }
  }
}